module.exports = __webpack_public_path__ + "img/dresser-var-02.62906668.png";